"use strict";

exports.__esModule = true;
var _ChangePartProcessActionElement = require("./ChangePartProcessActionElement");
Object.keys(_ChangePartProcessActionElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChangePartProcessActionElement[key]) return;
  exports[key] = _ChangePartProcessActionElement[key];
});
var _actions = require("./actions");
Object.keys(_actions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _actions[key]) return;
  exports[key] = _actions[key];
});